enum Endpoint {
  TIMETABLE_ENTRIES = '/timetableEntries',
  TIMETABLE_ENTRIES_UPDATE = '/timetableEntries/update',
  MONTHLY_WORKING_HOURS = '/monthlyWorkingHours',
  REPORT = '/report',
  CHANGE_WORK_HOUR = `/timetableEntries/reassign`,
}

export default Endpoint;
